import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import massive from "./components/massive";
import lightweight from "./components/lightweight";

const principle: Slide = {
  description:
    "Choose between a generic massive and a generic lightweight structure and see its sound reduction index in six different classes of sound insulation (A to F). Listen to everyday sounds in their original form and as they would be perceived through the chosen structure in all six classes. Use headphones. Set the volume on your device so that original male voice sounds realistically loud.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Massive" }, { name: "Lightweight" }],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], []],
      components: [massive, lightweight],
    },
  },
};

export default principle;
